import React from "react";
import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import RoleRow from "./RoleRow";
import { Pagination, Spinner } from "@services/ui-components";
import { RoleProxy } from "@me-team/host/main/graphql/types";
import { useRoleManagementContext } from "../context/RoleManagementContext";

const RoleManagementTable: React.FC = () => {
    const { t: translate } = useTranslation();
    const {
        roleData,
        roleDataLoading,
        currentPage,
        pageCount,
        totalItems,
        firstItemIndex,
        lastItemIndex,
        handlePageChange,
    } = useRoleManagementContext();
    const roles = roleData?.role?.roles ?? [];

    if (roleDataLoading || !roleData) return <Spinner />;

    return (
        <>
            <Table responsive className="mb-0 align-middle scrollbar table-category-width">
                <thead>
                    <tr className="fs-7">
                        <th className="col-3 py-3 px-3">{translate("Role Name")}</th>
                        <th className="col-6 py-3 px-3">{translate("Role Description")}</th>
                        <th className="col-3 py-3 px-3 text-end" />
                    </tr>
                </thead>

                <tbody>
                    {roles.map((role: RoleProxy) => (
                        <RoleRow key={role.id} role={role} />
                    ))}
                </tbody>
            </Table>
            {roles.length !== 0 && (
                <div className="d-flex justify-content-between align-items-center my-4">
                    <Pagination
                        t={translate}
                        pages={pageCount}
                        currentPage={currentPage}
                        onPageChange={handlePageChange}
                        firstItemIndex={firstItemIndex}
                        lastItemIndex={lastItemIndex}
                        totalItems={totalItems}
                    />
                </div>
            )}
        </>
    );
};

export default React.memo(RoleManagementTable);
